import React from "react";
import { useSelector } from "react-redux";

import { graphql } from "gatsby";

import { Container, Seo, Product, ProductCardGQL } from "../components";
import { SinglePostWrapper } from "../elements";
const SinglePost = ({ data, location }) => {
  const locale = useSelector((state) => state.localeString);
  const isDark = useSelector((state) => state.isDark);
  return (
    // <SinglePostWrapper isDark={isDark}>
    <Container pathname={location.pathname} locale={locale} isDark={isDark}>
      <Seo />
      <div className={"GQLContainer"}>
        <ProductCardGQL data={data} isDark={isDark} />
      </div>
    </Container>
    // </SinglePostWrapper>
  );
};
export default SinglePost;

export const pageQuery = graphql`
  query SinglePostTemplateQuery($id: String!) {
    mdx(id: { eq: $id }) {
      body
      frontmatter {
        date
        excerpt
        slug
        title
        location
        title
        motives
        excerpt
        date
        price
        shipping
        featureImage {
          childImageSharp {
            gatsbyImageData(width: 200)
          }
        }
      }
    }
  }
`;
